import { useState } from 'react';

function TruncatedText({ value, limit = 100 }) {
  const [expanded, setExpanded] = useState(false);

  if (value == null || (typeof value === 'string' && value.trim() === '')) {
    return <span>-</span>;
  }

  const stringValue = String(value); // convert boolean, number, etc.
  const isLong = stringValue.length > limit;
  const displayedValue = expanded || !isLong ? stringValue : stringValue.slice(0, limit) + '...';

  return (
    <>
      {displayedValue}
      {isLong && (
        <button onClick={() => setExpanded(!expanded)} className="btn-text-link">
          {expanded ? 'less' : 'more'}
        </button>
      )}
    </>
  );
}

export default TruncatedText;
